<template>
  <div>
    <div class="ui zw align-content-center">
      <img width="100px" class="ui image" :src="failImage" alt="Failed">

      <h1 class="header">{{ $t('globals.checkout.failed.title') }}</h1>
      <div class="ui divider"></div>

      <div class="fail-block">
        <p>{{ $t('globals.checkout.failed.vipps.text') }}</p>
        <a href="#" class="ui blue button" @click.prevent="handleRedirect">{{ $t('globals.checkout.failed.button_text') }}</a>
      </div>
    </div>

    <template v-if="isLocalEnv">
      <loading :active.sync="isLoading"
               :is-full-page="fullPage"/>
    </template>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import failedImage from '../../../assets/images/payment/failed_icon.png'

export default {
  name: 'VippsFailed',

  data () {
    return {
      paymentId: null,
      container: null,
      containerId: null,
      endpoint: null,
      isLoading: false,
      fullPage: true
    }
  },

  components: {
    Loading
  },

  mounted () {
    let queryParams = this.$route.query

    if (!queryParams.container) {
      this.$router.push('/dashboard')
    } else {
      this.container = queryParams.container
      this.containerId = queryParams.containerId
    }
  },

  methods: {
    handleRedirect() {
      if (this.container === 'booked') {
        this.$router.push({name: 'bookings'})
      } else {
        this.redirect(this.container)
      }
    },

    redirect (container) {
      if (container === 'subscriptions') {
        this.$router.push({name: 'dashboard'}, () => {
          this.$router.go()
        })
      } else {
        this.$router.push({name: 'wait_list'},
          () => {
            this.$router.go()
          }
        )
      }
    }
  },

  computed: {
    isLocalEnv() {
      return process.env.NODE_ENV === 'local';
    },

    failImage() {
      return failedImage;
    },

    getContainerName() {
      if (this.container === 'subscriptions') {
        return this.$t('globals.container.subscription')
      } else if (this.container === 'waitlistsubscriptions') {
        return this.$t('globals.container.waitlist')
      } else {
        return this.$t('globals.container.booked')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.align-content-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;

  .fail-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/payment/vipps/Failed.vue